import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import CustomButton1 from "../Button/CustomButton1";
import { useNavigate } from "react-router-dom";

interface modalProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const PhoneAlreadyReg: React.FC<modalProps> = ({ setOpen }) => {
  const Navigate = useNavigate();
  const handleNavigate = () => {
    setOpen(false);
    Navigate("/Signup");
  };

  return (
    <MainBox>
      <IconButton
          onClick={() => setOpen(false)}
        sx={{ position: "absolute", top: 10, right: 10, fontSize: "24px" }}
      >
        <CloseIcon />
      </IconButton>
      <Sub1Box>
        <Box>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              color: "#4C2D2D",
              lineHeight: "21.68px",
              padding: "20px",
              textAlign: "center",
            }}
          >
           Phone Number Registered
          </Typography>
          <Box
            sx={{
              backgroundColor: "#0c0c0c",
              height: "0.5px",
              width: "448px",
            }}
          />
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 400,
              color: "#4C2D2D",
              lineHeight: "21.68px",
              padding: "20px 0",
              width: "448px",
              textAlign:"center"
            }}
          >
            This phone number used is already registered.
            <br />
            <br />
            Please sign in, or use a different phone number to create a new account.
          </Typography>
          <Box
            sx={{
              backgroundColor: "#0c0c0c",
              height: "0.5px",
              width: "448px",
            }}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px 0px 20px 0px",
            }}
          >
            <CustomButton1
              name="Back to Home"
              variant="primary"
              padding="5px 15px"
              onClick={handleNavigate}
            />
          </Box>
        </Box>
      </Sub1Box>
    </MainBox>
  );
};

export default PhoneAlreadyReg;

const MainBox = styled(Box)`
  display: flex;
  flex-direction: column;
  background-color: #f6f5f5;
  border-radius: 10px;
  padding: 48px;
  justify-content: center;
  align-items: center;
`;
const SubBox = styled(Box)`
  display: flex;
  flex-direction: column;
  background-color: #f6f5f5;
  border-radius: 10px;
  padding: 20px;
  justify-content: center;
  align-items: center;
`;
const Sub1Box = styled(Box)`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 16px;
  justify-content: center;
`;
